import { MapPin, Navigation, Phone, DoorOpen, Calendar as CalIcon, Clock } from "lucide-react";
import { formatDateFR } from "@/lib/dates";

export const CLIMOMAX_ADDRESS = "10 rue Régis Huillier, 13800 Istres — Porte 10 (CLIMOMAX)";
export const CLIMOMAX_PHONE = "07 54 89 67 56";
export const CLIMOMAX_PHONE_TEL = "0754896756";
export const CLIMOMAX_MAPS_URL =
  "https://www.google.com/maps/dir/?api=1&destination=" +
  encodeURIComponent("10 rue Regis Huillier 13800 Istres");
export const ACCESS_PHOTO_URL =
  "https://customer-assets-0z36b82j.emergentagent.net/job_recharge-rapide-clim/artifacts/itqviihz_local%20CLIMOMAX.png";

export default function AccessInfo({ date, startTime, endTime }) {
  return (
    <div className="text-left" data-testid="access-info">
      <div className="flex items-center gap-2 mb-4">
        <DoorOpen className="w-5 h-5 text-[#00B4D8]" />
        <h4 className="font-heading text-lg font-bold text-white">Comment venir au rendez-vous</h4>
      </div>

      {(date || startTime) && (
        <div className="flex flex-wrap gap-x-5 gap-y-2 mb-4 text-sm">
          {date && (
            <span className="flex items-center gap-1.5 text-white" data-testid="access-date">
              <CalIcon className="w-4 h-4 text-[#00B4D8]" /> {formatDateFR(date)}
            </span>
          )}
          {startTime && (
            <span className="flex items-center gap-1.5 text-white" data-testid="access-time">
              <Clock className="w-4 h-4 text-[#00B4D8]" /> {startTime}{endTime ? ` – ${endTime}` : ""}
            </span>
          )}
        </div>
      )}

      <div className="bg-[#050810] border border-[#FFD60A]/40 rounded-lg p-4 mb-4">
        <div className="flex items-start gap-3 mb-3">
          <MapPin className="w-5 h-5 text-[#FFD60A] shrink-0 mt-0.5" />
          <div>
            <p className="text-base text-white font-bold leading-snug">{CLIMOMAX_ADDRESS}</p>
            <a
              href={CLIMOMAX_MAPS_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="access-itinerary-link"
              className="inline-flex items-center gap-1.5 mt-1.5 text-sm font-bold text-[#00B4D8] hover:underline"
            >
              <Navigation className="w-4 h-4" /> Obtenir l'itinéraire
            </a>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <Phone className="w-5 h-5 text-[#FFD60A] shrink-0" />
          <a
            href={`tel:${CLIMOMAX_PHONE_TEL}`}
            data-testid="access-phone-link"
            className="text-base text-white font-bold hover:text-[#00B4D8] transition"
          >
            {CLIMOMAX_PHONE}
          </a>
        </div>
      </div>

      <div className="bg-[#00B4D8]/10 border border-[#00B4D8]/30 rounded-lg p-4 mb-4">
        <p className="text-sm text-white leading-relaxed">
          <span className="font-bold text-[#00B4D8]">Repérez la Porte N°10.</span> En arrivant, dirigez-vous
          vers la <span className="font-bold">3ème porte</span> — la <span className="font-bold">Porte N°10</span>,
          sur votre <span className="font-bold">droite</span>.
        </p>
      </div>

      <div className="rounded-xl overflow-hidden border border-[#1A2642]">
        <img
          src={ACCESS_PHOTO_URL}
          alt="Accès CLIMOMAX — Porte N°10, 3ème porte sur votre droite"
          className="w-full object-cover"
          data-testid="access-photo"
        />
      </div>
    </div>
  );
}
